module.exports = __webpack_public_path__ + "img/code-review.b3338197.webp";